"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _validate = require("@/utils/validate");
var _UserDivisionConfigPanel = _interopRequireDefault(require("./components/UserDivisionConfigPanel.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------

var defaultObj = {
  id: null,
  mark: '',
  addres: '',
  groupId: '',
  level: '',
  isPromoter: false,
  status: false,
  jeequanReceiverId: ''
};
var _default = exports.default = {
  name: 'UserEdit',
  components: {
    UserDivisionConfigPanel: _UserDivisionConfigPanel.default
  },
  props: {
    userInfo: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      ruleForm: Object.assign({}, defaultObj),
      groupData: [],
      labelData: [],
      rules: {},
      labelLists: []
    };
  },
  computed: {
    userAddress: function userAddress() {
      return "".concat(this.ruleForm.province || '').concat(this.ruleForm.city || '');
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler: function handler(value) {
        this.initializeForm(value);
      }
    }
  },
  mounted: function mounted() {
    this.labelLists = JSON.parse(localStorage.getItem('tagAllList')) || [];
  },
  methods: {
    initializeForm: function initializeForm(userInfo) {
      this.ruleForm = Object.assign({}, defaultObj, userInfo ? JSON.parse(JSON.stringify(userInfo)) : {});
      var tagId = this.ruleForm.tagId || '';
      this.labelData = tagId ? tagId.split(',').map(Number) : [];
    },
    handleDivisionConfigUpdated: function handleDivisionConfigUpdated(detail) {
      this.$set(this.ruleForm, 'jeequanReceiverId', detail && detail.jeequanReceiverId || '');
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.ruleForm.tagId = _this.labelData.join(',');
          (0, _user.userUpdateApi)({
            id: _this.ruleForm.id
          }, _this.ruleForm).then(function () {
            _this.$message.success('编辑成功');
            _this.$emit('success');
          });
        } else {
          return false;
        }
      });
    }),
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('resetForm');
    }
  }
};